module.exports = __webpack_public_path__ + "static/media/10.5ee29806.svg";